
import produce from 'immer';

import {
    IInitialState,
} from './interface';

import {
    SEND_WEBCHAT_MESSAGE,
    SEND_WEBCHAT_MESSAGE_FAILED,
    SEND_WEBCHAT_MESSAGE_SUCCESS,
} from './constants';

/**
 * initialState
 */
export const initialState: IInitialState = {
    loading: false,
    error: false,
    errorCode: false,
    message: false,
};

/**
 * appReducer
 * @param state
 * @param action
 */
const sendWebchatMessageReducer = (state: any = initialState, action: any) =>
    produce(state, (draft: IInitialState) => {

        switch (action.type) {
            case SEND_WEBCHAT_MESSAGE:
                draft.loading = true;
                draft.message = action.message;
                draft.error = false;
                draft.errorCode = false;
                break;
            case SEND_WEBCHAT_MESSAGE_SUCCESS:
                draft.loading = false;
                break;
            case SEND_WEBCHAT_MESSAGE_FAILED:
                draft.loading = false;
                draft.error = action.error;
                draft.errorCode = action.errorCode;
                break;

        }
    });

export default sendWebchatMessageReducer;
